import styled from "styled-components";

import {
	BettoAlertActions,
	BettoAlertCard,
	BettoAlertCloseButton,
	BettoAlertContent,
	BettoAlertCopy,
	BettoAlertOverlay,
	BettoAlertPrimaryButton,
	BettoAlertSecondaryButton,
	BettoAlertTitle,
} from "@layouts/betto/components/Alert/BettoAlertModal.styles";

export const BettoShareModalOverlay = styled(BettoAlertOverlay)`
	z-index: 1300;
	align-items: center;
	padding: 20px 16px;
`;

export const BettoShareModalCard = styled(BettoAlertCard)`
	width: min(400px, calc(100vw - 32px));
	overflow: visible;
`;

export {
	BettoAlertCloseButton as BettoShareModalCloseButton,
	BettoAlertCopy as BettoShareModalCopy,
	BettoAlertTitle as BettoShareModalTitle,
	BettoAlertActions as BettoShareModalActions,
	BettoAlertPrimaryButton as BettoShareModalPrimaryButton,
	BettoAlertSecondaryButton as BettoShareModalSecondaryButton,
};

export const BettoShareModalContent = styled(BettoAlertContent)`
	padding-top: 48px;
	overflow: visible;
`;

export const BettoShareModalField = styled.div`
	width: 100%;
	position: relative;
	z-index: 1;

	.ant-form-item {
		margin-bottom: 0;
		width: 100%;
	}

	.ant-select-selection-search-input {
		color: var(--bt-auth-heading-color, #e5f0fe) !important;
		padding-left: 0 !important;
	}
`;
